var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for ENS",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ENS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "url(#paint0_linear_3300_8577)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3300_8577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6754 44.759C29.3356 46.1459 30.9862 48.9197 30.9862 48.9197L49.8858 18L31.4814 30.7268C30.4085 31.4611 29.5007 32.4401 28.8404 33.5822C27.1073 37.0902 27.1073 41.1693 28.6754 44.759Z",
    fill: "url(#paint1_linear_3300_8577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2476 54.8752C21.6603 60.8307 24.7139 66.3782 29.5007 69.9679L49.8858 84C49.8858 84 37.0935 65.8072 26.3645 47.6959C25.2916 45.8195 24.5488 43.6984 24.2187 41.4957C24.0537 40.5167 24.0537 39.5377 24.2187 38.5587C23.9711 39.0482 23.3934 40.1088 23.3934 40.1088C22.3205 42.3115 21.5777 44.6774 21.1651 47.1248C20.9175 49.7355 20.9175 52.3461 21.2476 54.8752Z",
    fill: "#A0A8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2421 57.3226C72.5818 55.9357 70.9312 53.1619 70.9312 53.1619L52.0316 83.9999L70.5185 71.3547C71.5915 70.6205 72.4993 69.6415 73.1595 68.4993C74.8102 64.9913 74.8927 60.9122 73.2421 57.3226Z",
    fill: "url(#paint2_linear_3300_8577)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7524 47.1248C80.3398 41.1693 77.2861 35.6218 72.4993 32.0321L52.1142 18C52.1142 18 64.9065 36.1928 75.6355 54.3041C76.7084 56.1805 77.4512 58.3016 77.7813 60.5043C77.9464 61.4833 77.9464 62.4623 77.7813 63.4413C78.0289 62.9518 78.6066 61.8912 78.6066 61.8912C79.6795 59.6885 80.4223 57.3226 80.835 54.9567C81 52.2645 81 49.7355 80.7524 47.1248Z",
    fill: "#A0A8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8406 33.5822C29.5009 32.4401 30.3262 31.4611 31.4816 30.7268L49.886 18L30.9864 48.8381C30.9864 48.8381 29.3358 46.0643 28.6756 44.6774C27.1075 41.1693 27.1075 37.0902 28.8406 33.5822ZM21.2478 54.8752C21.6604 60.8307 24.7141 66.3782 29.5009 69.9679L49.886 84C49.886 84 37.0937 65.8072 26.3647 47.6959C25.2918 45.8195 24.549 43.6984 24.2189 41.4957C24.0538 40.5167 24.0538 39.5377 24.2189 38.5587C23.9713 39.0482 23.3936 40.1088 23.3936 40.1088C22.3207 42.3115 21.5779 44.6774 21.1653 47.1248C20.9177 49.7355 20.9177 52.3461 21.2478 54.8752ZM73.2423 57.3226C72.582 55.9357 70.9314 53.1619 70.9314 53.1619L52.0318 84L70.5188 71.3548C71.5917 70.6205 72.4995 69.6415 73.1598 68.4994C74.8104 64.9913 74.8929 60.9122 73.2423 57.3226ZM80.6701 47.2064C80.2574 41.2509 77.2038 35.7033 72.417 32.1137L52.1144 18C52.1144 18 64.9067 36.1928 75.6357 54.3041C76.7086 56.1805 77.4514 58.3016 77.7815 60.5043C77.9466 61.4833 77.9466 62.4623 77.7815 63.4413C78.0291 62.9518 78.6068 61.8912 78.6068 61.8912C79.6797 59.6885 80.4225 57.3226 80.8351 54.9567C81.0002 52.2645 81.0002 49.7355 80.6701 47.2064Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3300_8577",
    x1: -3,
    y1: -15.5,
    x2: 79,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5260FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326159,
    stopColor: "#527EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3300_8577",
    x1: 50.7455,
    y1: 18.7735,
    x2: 26.7992,
    y2: 45.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A0A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6470B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3300_8577",
    x1: 51.2547,
    y1: 83.2808,
    x2: 75.1921,
    y2: 57.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A0A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6470B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3300_8577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 66,
    fill: "white",
    transform: "translate(21 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ens.19322a622f8424534e5d8dd536c30df5.svg";
export { ForwardRef as ReactComponent };